/*
 * Заменяет параметры в URL-шаблоне OpenAPI
 * @example replaceOpenApiUrlParam('/api/tokens/{tokenId}', { tokenId: '123' })
 * @example replaceOpenApiUrlParam('/api/{version}/users/{userId}', { version: 'v1', userId: '456' })
 */
export const replaceOpenApiUrlParam = (url: string, params: Record<string, string | number>): string => {
    let result = url;

    for (const [key, value] of Object.entries(params)) {
        result = result.replace(`{${key}}`, String(value));
    }

    return result;
};
